module.exports = __webpack_public_path__ + "img/undraw_High_five.dd2d3ef8.svg";